import zxcvbn from 'zxcvbn';

import passwordStrengthConfig from '../../../../config/password_strength.json';

export const MIN_PASSWORD_SCORE = passwordStrengthConfig.minScore;

export const ERROR_WEAK_PASSWORD =
  'Password is too weak. Try a longer phrase, or add numbers and symbols.';

// strengthInputs is an array of values that, if used to derive the password, will
// negatively impact the score of that password. For example, if a user uses their email
// as a part of their password, the score will be lower if the email is included in the
// strengthInputs array.
export const getPasswordScore = ({ password, strengthInputs = [] }) => {
  if (!password) return 0;

  return zxcvbn(password, strengthInputs.filter(Boolean)).score;
};

export const meetsMinPasswordScore = ({ password, strengthInputs = [] }) =>
  getPasswordScore({ password, strengthInputs }) >= MIN_PASSWORD_SCORE;
